import React, { FC } from 'react'

import styles from './NavigationHeaderPreloader.module.scss'

export const NavigationHeaderPreloader: FC = () => (
  <div className={styles.NavigationHeaderPreloader}>
    <div className={styles.LoaderImage} />
  </div>
)
